module.exports = __webpack_public_path__ + "static/media/void.47de1f41.svg";